"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames } from "@opensea/ui-kit";
import { useEffect, useMemo, useState } from "react";
const DEFAULT_COLLAPSED_WIDTH_PX = 52;
export function useExplicitEnterHoverGate(options) {
  const $ = _c(20);
  let t0;
  if ($[0] !== options) {
    t0 = options ?? {};
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    side: t1,
    collapsedWidthPx: t2,
    resetKey
  } = t0;
  const side = t1 === undefined ? "left" : t1;
  const collapsedWidthPx = t2 === undefined ? DEFAULT_COLLAPSED_WIDTH_PX : t2;
  const [gated, setGated] = useState(true);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setGated(true);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== resetKey) {
    t4 = [resetKey];
    $[3] = resetKey;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[5] !== collapsedWidthPx || $[6] !== gated || $[7] !== side) {
    t5 = () => {
      if (!gated) {
        return;
      }
      let rafId;
      const state = {
        wasOutside: false,
        startX: undefined,
        startY: undefined
      };
      const handlePointerMove = event => {
        const x = event.clientX;
        const y = event.clientY;
        const viewportWidth = window.innerWidth;
        const isInside = side === "left" ? x >= 0 && x <= collapsedWidthPx : x >= viewportWidth - collapsedWidthPx && x <= viewportWidth;
        if (state.startX === undefined || state.startY === undefined) {
          state.startX = x;
          state.startY = y;
        }
        if (state.startX !== undefined && state.startY !== undefined) {
          const dx = x - state.startX;
          const dy = y - state.startY;
          const movedDistancePx = Math.hypot(dx, dy);
          if (movedDistancePx >= collapsedWidthPx * 2) {
            rafId = window.requestAnimationFrame(() => {
              setGated(false);
            });
            return;
          }
        }
        if (!isInside) {
          state.wasOutside = true;
        } else {
          if (state.wasOutside) {
            rafId = window.requestAnimationFrame(() => {
              setGated(false);
            });
          }
        }
      };
      window.addEventListener("pointermove", handlePointerMove, {
        passive: true
      });
      return () => {
        window.removeEventListener("pointermove", handlePointerMove);
        if (rafId !== undefined) {
          window.cancelAnimationFrame(rafId);
        }
      };
    };
    t6 = [gated, side, collapsedWidthPx];
    $[5] = collapsedWidthPx;
    $[6] = gated;
    $[7] = side;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  bb0: {
    if (!gated) {
      t7 = null;
      break bb0;
    }
    const sideClassName = side === "left" ? "left-0" : "right-0";
    let t8;
    if ($[10] !== sideClassName) {
      t8 = classNames("pointer-events-none fixed inset-y-0 z-top", sideClassName);
      $[10] = sideClassName;
      $[11] = t8;
    } else {
      t8 = $[11];
    }
    let t9;
    if ($[12] !== collapsedWidthPx) {
      t9 = {
        width: collapsedWidthPx
      };
      $[12] = collapsedWidthPx;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    let t10;
    if ($[14] !== t8 || $[15] !== t9) {
      t10 = <div aria-hidden={true} className={t8} style={t9} />;
      $[14] = t8;
      $[15] = t9;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    t7 = t10;
  }
  const overlay = t7;
  let t8;
  if ($[17] !== gated || $[18] !== overlay) {
    t8 = {
      overlay,
      gated
    };
    $[17] = gated;
    $[18] = overlay;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}